export default "__VITE_ASSET__BsKL$23___"